var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leftItem",staticStyle:{"color":"#fff"}},[_c('populationBaseInfo'),_c('healthManagement'),_c('activity'),_c('activityChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }